import React, { useState, useEffect, useRef } from "react";
import {
  SafText,
  SafAnchor,
  SafCombobox,
  SafOption,
  SafButton,
} from "@saffron/core-components/react";
import { CosmosClient } from "@azure/cosmos";
import { Link, useNavigate } from "react-router-dom";
import { Breadcrumb } from "../../../shared";

const Customruntime = () => {
  const navigate = useNavigate();
  const [isInvalid, setInvalid] = useState(false);
  const [technologyNameValue, setTechnologyNameValue] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [capabilityValue, setCapabilityValue] = useState("");
  const [supportingPatternValue, setSupportingPatternValue] = useState("");
  const [recommendationValue, setRecommendationValue] = useState("");
  const [providerValue, setProviderValue] = useState("");
  const [technologyName, setTechnologyName] = useState([]);
  const [capabilities, setCapabilities] = useState([]);
  const [supportingPatterns, setSupportingPatterns] = useState([]);
  const [recommendations, setRecommendations] = useState([]);
  const [providers, setProviders] = useState([]);
  const [customruntime, setCustomruntime] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const comboboxRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      const endpoint = process.env.REACT_APP_COSMOS_ENDPOINT;
      const key = process.env.REACT_APP_COSMOS_KEY;
      const client = new CosmosClient({ endpoint, key });
      const databaseId = process.env.REACT_APP_DB_SOURCE;
      const containerId = "tech-stack-mapping";

      try {
        const { resources } = await client
          .database(databaseId)
          .container(containerId)
          .items.query("SELECT * FROM c")
          .fetchAll();

        const uniqueCategoryList = [
          ...new Set(resources.map((item) => item.category)),
        ];
        setCategoryList(uniqueCategoryList);

        const uniqueTechnologyName = [
          ...new Set(
            resources.flatMap((item) =>
              item.capabilities.flatMap((cap) =>
                cap.services.map((service) => service.technology_name)
              )
            )
          ),
        ];
        setTechnologyName(uniqueTechnologyName);

        const uniqueCapabilities = [
          ...new Set(
            resources.flatMap((item) =>
              item.capabilities.map((cap) => cap.capability)
            )
          ),
        ];
        setCapabilities(uniqueCapabilities);

        // Supporting patterns are left empty as per your request
        setSupportingPatterns([]);

        const uniqueRecommendations = [
          ...new Set(
            resources.flatMap((item) =>
              item.capabilities.flatMap((cap) =>
                cap.services.map((service) => service.recommendation)
              )
            )
          ),
        ];
        setRecommendations(uniqueRecommendations);

        const uniqueProviders = [
          ...new Set(
            resources.flatMap((item) =>
              item.capabilities.flatMap((cap) =>
                cap.services.map((service) => service.provider)
              )
            )
          ),
        ];
        setProviders(uniqueProviders);
      } catch (error) {
        console.error("Error fetching data from Cosmos DB:", error);
      }
    };

    fetchData();
  }, []);

  const handleCategoryNameChange = (event) => {
    setCategoryName(event.target.value);
  };

  const handleTechnologyNameChange = (event) => {
    setTechnologyNameValue(event.target.value);
  };

  const handleCapabilityChange = (event) => {
    setCapabilityValue(event.target.value);
  };

  const handleSupportingPatternChange = (event) => {
    setSupportingPatternValue(event.target.value);
  };

  const handleRecommendationChange = (event) => {
    setRecommendationValue(event.target.value);
  };

  const handleProviderChange = (event) => {
    setProviderValue(event.target.value);
  };

  const onValidate = () => {
    setInvalid(
      !categoryName ||
        !capabilityValue ||
        !technologyNameValue ||
        !recommendationValue ||
        !providerValue
    );
  };

  const handleAddRuntime = () => {
    if (
      categoryName &&
      capabilityValue &&
      technologyNameValue &&
      recommendationValue
    ) {
      const newRuntime = {
        categoryName: categoryName,
        capability: capabilityValue,
        technologyName: technologyNameValue,
        supportingPattern: supportingPatternValue,
        recommendation: recommendationValue,
        provider: providerValue,
      };

      setCustomruntime([...customruntime, newRuntime]);

      // Clear the input fields
      setCapabilityValue("");
      setTechnologyNameValue("");
      setSupportingPatternValue("");
      setRecommendationValue("");
      setProviderValue("");
      setCategoryName("");

      // Get the assetInfo from localStorage
      const assetInfo = JSON.parse(localStorage.getItem("assetInfo"));

      // Navigate to the TechnologyStacks page with the new custom runtime data and assetInfo
      navigate("/technology-stacks", {
        state: {
          customRuntimeData: [newRuntime],
          isCustomRuntime: true,
          assetInfo: assetInfo,
        },
      });
    } else {
      setInvalid(true);
    }
  };
  return (
    <div style={{ marginTop: "50px" }}>
      <div className="breadcrumb-section">
        <Breadcrumb />
      </div>
      <br />
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <SafText appearance="heading-2xl">Add Custom Runtime</SafText>
        <SafAnchor href="/addtechstack">
          <SafText appearance="body-strong-sm" style={{ float: "left" }}>
            Select from database
          </SafText>
        </SafAnchor>
      </div>

      <p>
        <SafText appearance="body-default-sm">
          Select capability from the database or add your own custom capability
        </SafText>
      </p>

      <div style={{ width: "70%" }}>
        <div
          className="Component-demo Component-demo--centered"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <SafCombobox
            id="combobox-capability-items"
            name="Capability Item"
            autocomplete="inline"
            onClick={handleTechnologyNameChange}
            onBlur={onValidate}
            ref={comboboxRef}
            label="Technology Name"
            validationMessage={
              isInvalid && !technologyNameValue
                ? "Please select a capability item!"
                : ""
            }
            optionalText=""
            invalid={isInvalid && !technologyNameValue}
            required
            value={technologyNameValue}
            style={{ width: "300px" }}
          >
            {technologyName.map((item, index) => (
              <SafOption key={index}>{item}</SafOption>
            ))}
          </SafCombobox>

          <SafCombobox
            id="combobox-capabilities"
            name="Capability"
            autocomplete="inline"
            onClick={handleCapabilityChange}
            onBlur={onValidate}
            label="Capability"
            validationMessage={
              isInvalid && !capabilityValue ? "Please select a capability!" : ""
            }
            invalid={isInvalid && !capabilityValue}
            required
            value={capabilityValue}
            style={{ width: "300px" }}
          >
            {capabilities.map((capability, index) => (
              <SafOption key={index}>{capability}</SafOption>
            ))}
          </SafCombobox>
        </div>

        <div
          className="Component-demo Component-demo--centered"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <SafCombobox
            id="combobox-supporting-patterns"
            name="Supporting Pattern"
            autocomplete="inline"
            onClick={handleSupportingPatternChange}
            // onBlur={onValidate}
            label="Supporting Pattern"
            value={supportingPatternValue}
            style={{ width: "300px" }}
          >
            {supportingPatterns.map((pattern, index) => (
              <SafOption key={index}>{pattern}</SafOption>
            ))}
          </SafCombobox>

          <SafCombobox
            id="combobox-recommendations"
            name="Recommendation"
            autocomplete="inline"
            onClick={handleRecommendationChange}
            onBlur={onValidate}
            label="Recommendation"
            validationMessage={
              isInvalid && !recommendationValue
                ? "Please select a recommendation!"
                : ""
            }
            invalid={isInvalid && !recommendationValue}
            required
            value={recommendationValue}
            style={{ width: "300px" }}
          >
            {recommendations.map((recommendation, index) => (
              <SafOption key={index}>{recommendation}</SafOption>
            ))}
          </SafCombobox>
        </div>

        <div
          className="Component-demo Component-demo--centered"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <SafCombobox
            id="combobox-providers"
            name="Provider"
            autocomplete="inline"
            onClick={handleProviderChange}
            // onBlur={onValidate}
            label="Provider"
            // validationMessage={
            //   isInvalid && !providerValue ? "Please select a provider!" : ""
            // }
            // invalid={isInvalid && !providerValue}
            // required
            value={providerValue}
            style={{ width: "300px" }}
          >
            {providers.map((provider, index) => (
              <SafOption key={index}>{provider}</SafOption>
            ))}
          </SafCombobox>
          <SafCombobox
            id="combobox-category-items"
            name="Category Item"
            autocomplete="inline"
            onClick={handleCategoryNameChange}
            onBlur={onValidate}
            ref={comboboxRef}
            label="Category"
            validationMessage={
              isInvalid && !categoryName ? "Please select a Category item!" : ""
            }
            optionalText=""
            invalid={isInvalid && !categoryName}
            required
            value={categoryName}
            style={{ width: "300px" }}
          >
            {categoryList.map((item, index) => (
              <SafOption key={index}>{item}</SafOption>
            ))}
          </SafCombobox>
        </div>
      </div>
      <br />
      <hr style={{ marginTop: "90px" }}></hr>
      <br />
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          <Link to={"/technology-stacks"}>
            <SafButton appearance="secondary">Cancel</SafButton>
          </Link>

          <SafButton
            appearance="primary"
            style={{ marginLeft: "20px" }}
            onClick={handleAddRuntime}
          >
            Add to runtime
          </SafButton>
        </div>
        <div>
          <Link to="/delete">
            <SafButton>Delete</SafButton>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Customruntime;
